import predicates from '.'

export default predicates.map((predicate) => predicate.option)
